import { CursorType } from "../cursor-type";
import { CanvasSideMenuCIM } from "./side-menu-cim";
import { CanvasSideMenuStandard } from "./side-menu-standalone";

export interface CanvasSideMenuProps {
  currentCursorType: CursorType;
  onChangeCursorType: (type: CursorType) => void;
  setShowSidePanel: (enable: boolean) => void;
  toggleShowIntegrations: () => void;
  showSubmenu: boolean;
  setShowSubmenu: (show: boolean) => void;
  setCursorType: (type: CursorType) => void;
  showSideMenuOverflow: boolean;
  setShowSideMenuOverflow: (enable: boolean) => void;
  setShowRestrictedModal: (show: boolean) => void;
  isCimReorderEnabled: boolean;
}

export default function CanvasSideMenu(props: CanvasSideMenuProps) {
  if (props.isCimReorderEnabled) {
    return <CanvasSideMenuCIM {...props} />;
  }
  return <CanvasSideMenuStandard {...props} />;
}
